<template>
  <div class="root">
    <footer class="wrapper___SeDu_">
      <div class="header___2bkj8">
        <div class="left___1-v1R">
          <img src="../assets/images/logo.jpg"
               class="logo___2rbs6"
               alt="">
          <ul class="navs___3FPXl">
            <router-link v-for="(item,index) in footerData"
                         :key="index"
                         :to="item.urls">
              <li>
                <!--<img :src="item.iconed" alt="" v-if="routerName==item.desc||(routerName=='Allvideo'&&index==0)"  >-->
                <!--<img :src="item.icon" alt=""  v-else>-->
                <span :style="{color:routerName=='Allvideo'&&item.name=='视频'?'#FFB441':''}">{{item.name}}</span>
              </li>
            </router-link>

          </ul>
        </div>
        <div class="right___QblwF"
             v-if="wxuser?(wxuser?true:false):false">
          <div class="item___35ULC">
            <!--<img src="" alt="">-->
            <span @click="outLoader">退出登录</span>
          </div>
          <div class="item___35ULC">
            <el-dropdown @command="handleCommand">
            <span class="el-dropdown-link">
              <span class="icon iconfont">&#xf0350;</span>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="userinfo">个人信息</el-dropdown-item>
              <el-dropdown-item command="shareQrCode">账号分享</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          </div>
        </div>

        <!--<div class="right___QblwF login" v-if="!wxuser">-->
        <!--<span @click="tologin(1)">登录</span>-->
        <!--<span class="distinguish">|</span>-->
        <!--<span @click="tologin(2)">注册</span>-->
        <!--</div>-->
      </div>
      <div class="contact___1EtS-">
        <a class="item___1vaWw">
          <div class="icon___2lMs7">
            <span class="icon iconfont">&#xe614;</span>
          </div>
          <div class="qrcode___QlSyy">
            <img src="../assets/images/qrcode.jpg"
                 alt="">
            <span>
              扫码关注微信公众号
            </span>

          </div>

        </a>

        <a class="item___1vaWw"
           oncopy="return false">
          <div class="icon___2lMs7">
            <span class="icon iconfont">&#xe612;</span>
            <span class="back_top"
                  @click="toTop">返回顶部</span>
          </div>

        </a>

      </div>

    </footer>
    <router-view class="con_view"></router-view>

  </div>
</template>
<script>
import icon1 from '../assets/images/sp.png'
import icon2 from '../assets/images/live.png'
import icon3 from '../assets/images/me.png'
import icon4 from '../assets/images/column.png'

import ic1 from '../assets/images/1.png'
import ic2 from '../assets/images/2.png'
import ic3 from '../assets/images/3.png'
import ic4 from '../assets/images/columned.png'

import weui from "weui.js";
import '../assets/style/font1/iconfont.css'
import store from "../store";
import loginService from '../plugin/extendFn/loginService'
export default {
  data () {
    return {
      wxuser:null,
      footerData: [
        { name: "直播", icon: icon2, iconed: ic2, urls: "/index/live", desc: "Live" },
        { name: "视频", icon: icon1, iconed: ic1, urls: "/index/video", desc: "Video" },
        {name:"专栏",icon:icon4,iconed:ic4,urls:"/index/column",desc:"Column"},
        { name: "我的", icon: icon3, iconed: ic3, urls: "/index/me", desc: "Me" },
        { name: "会员", icon: icon3, iconed: ic3, urls: "/index/vip", desc: "Me" }
      ]
    }
  },
  props: {},
  methods: {
    handleCommand(command) {
        if(command=='userinfo')
        {
          this.$router.push({ name: 'userinfo', })
        }
        else  if(command=='shareQrCode')
        {
          this.$router.push({ name: 'ShareQRCode', })
        }
      },
    tologin (type) {
      if (type == 1) {
        this.$router.push({
          name: 'Login',
        })
      } else if (type == 2) {
        this.$router.push({
          name: 'Register',
        })
      }

    },
    outLoader () {
      loginService.logout();
      let url= window.location.href;
      if(url.includes('www.medcircle.cn')){
        /**注意：此处不能更换成 https; 否则电脑端不能观看直播 */
        window.location.href='http://www.medcircle.cn/cmdhra_pc/';
      }else {
        window.location.href='http://www.medcircle.top/cmdhra_pc/';
      }
    },
    toMore (type, name) {
      this.morenew = type;
      if (name == 1) {
        let params = {
          title: this.title,
          type: '',
          order: '',
        }
        sessionStorage.setItem('ra_more', JSON.stringify(params));
      } else {
        let params = {
          title: '',
          type: '',
          order: type,
        }
        sessionStorage.setItem('ra_more', JSON.stringify(params));
        // this.$router.push({
        //     name:'Allvideo',
        //     // query:{order:type,},
        // })
      }

    },
    userinfo () {
      this.$router.push({
        name: 'userinfo',
      })

    },
    toTop () {

      let top = document.body.scrollTop || document.documentElement.scrollTop
      scrollBy(0, -top);
    },
    toJump (url) {
      // console.log(this.$route);
      this.$router.push({
        name: desc,
      })
    },
  },
  computed: {
    routerName () {
      return this.$route.name

    }
  },
  async mounted () {
    this.wxuser=await loginService.getLoginUser();
    
    // console.log(this.$route)
  }
}
</script>
<style scoped lang="scss">

.con_view {
  overflow: hidden;
  width: 100%;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  -ms-flex-align: center;
  align-items: center;
  margin-top: 10px;
}
.root {
  width: 100%;
  min-width: 1280px;
  height: 100%;
  min-height: 100vh;
  /*background: url("../assets/images/details_bg.png") no-repeat;*/
  /*-webkit-background-size: 100% 100%;*/
  /*background-size: 100% 100%;*/
}
.iconfont {
  color: #999999;
  font-size: 28px;
  line-height: 28px;
}
.contact___1EtS- {
  position: fixed;
  right: 0;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  -ms-flex-align: center;
  align-items: center;
  width: 64px;
  border-radius: 4px;
  background-color: #fff;
  -webkit-box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.08);
  box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.08);
  z-index: 999999999;
  *zoom: 1;
  bottom: 80px;
  margin-top: -172px;
}
.wrapper___SeDu_ {
  width: 100%;
  height: 80px;
  -webkit-box-shadow: 0 3px 5px rgba(0, 0, 0, 0.08);
  box-shadow: 0 3px 5px rgba(0, 0, 0, 0.08);
  background: #fff;
  min-width: 1280px;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-pack: center;
  justify-content: center;
  .header___2bkj8 {
    width: 1176px;
    min-width: 1176px;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-align: center;
    align-items: center;
    .left___1-v1R {
      height: 100%;
      -ms-flex: 1 1;
      flex: 1 1;
      display: -ms-flexbox;
      display: flex;
      -ms-flex-align: center;
      align-items: center;
      .logo___2rbs6 {
        width: 60px;
        /*height: 36px;*/
        /*background: url(//assets.dxycdn.com/gitrepo/dxycourse-pc/dist/static/logo@2x.f8dfb866.png) no-repeat;*/
        background-size: 152px 36px;
        background-position: 0 0;
        color: transparent;
      }
      .navs___3FPXl {
        height: 100%;
        li {
          height: 100%;
          line-height: 80px;
          display: inline-block;
          color: #333;
          font-size: 16px;
          margin-left: 40px;
        }
      }
    }
    .distinguish {
      margin: 0 5px;
      font-size: 12px;
    }
    .login {
      color: #05a2ff;
      span {
        cursor: pointer;
      }
    }
    .right___QblwF {
      display: -ms-flexbox;
      display: flex;
      -ms-flex-align: center;
      align-items: center;
      height: 100%;
      -ms-flex: 1 1;
      flex: 1 1;
      -ms-flex-pack: end;
      justify-content: flex-end;
      .item___35ULC {
        .avatar___2Qt4g {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          border: 2px solid #fff;
        }
        height: 100%;
        display: -ms-flexbox;
        display: flex;
        -ms-flex-direction: column;
        flex-direction: column;
        -ms-flex-align: center;
        align-items: center;
        -ms-flex-pack: center;
        justify-content: center;
        margin-left: 41px;
        cursor: pointer;
        position: relative;
      }
      .search___1FrwO {
        position: relative;
        width: 296px;
        height: 36px;
        border-radius: 18px;
        background: #f2f2f2;
        display: -ms-flexbox;
        display: flex;
        -ms-flex-align: center;
        align-items: center;
        .searchBox___joiqa {
          outline: none;
          border: none;
          -ms-flex: 1 1;
          flex: 1 1;
          background: #f2f2f2;
          height: 36px;
          padding-left: 27px;
          font-size: 14px;
          color: #999;
          line-height: 20px;
          border-radius: 18px;
          -webkit-appearance: none;
        }
        .iconWrapper___3GNet {
          width: 56px;
          height: 36px;
          background-image: linear-gradient(-179deg, #ffb441, #ffb441);
          display: -ms-flexbox;
          display: flex;
          -ms-flex-align: center;
          align-items: center;
          -ms-flex-pack: center;
          justify-content: center;
          border-top-right-radius: 18px;
          border-bottom-right-radius: 18px;
          img {
            width: 20px;
            height: 20px;
          }
        }
      }
    }
  }

  .router-link-active {
    background: #ffffff;
    span {
      color: #05a2ff !important;
    }
    li{
      color: #05a2ff !important;
    }
    color: #05a2ff !important;
  }
}
.qrcode___QlSyy {
  position: absolute;
  width: 120px;
  left: -126px;
  top: -26px;
  z-index: 10000;
  font-size: 12px;
  color: #666;
  text-align: center;
  background: #fff;
  padding: 6px 0 8px;
  line-height: 16px;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  -ms-flex-align: center;
  align-items: center;
  display: none;
  img {
    width: 106px;
    height: 106px;
    vertical-align: middle;
    border-style: none;
  }
}
.icon___2lMs7 {
  width: 30px;
  height: 30px;
  font-size: 12px;
  text-align: center;
}
.item___1vaWw:nth-of-type(1):after {
  content: "";
  position: absolute;
  bottom: 0;
  width: 20px;
  height: 1px;
  background: #ebebeb;
}
.item___1vaWw:nth-of-type(1):hover {
  .qrcode___QlSyy {
    display: flex !important;
  }
}
.item___1vaWw:nth-of-type(2):hover {
  .qrcode___QlSyy {
    display: flex;
  }
  .icon {
    display: none;
  }
  .back_top {
    display: block !important;
    color: #ffb441;
    font-size: 12px;
  }
}
.item___1vaWw {
  position: relative;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-pack: center;
  justify-content: center;
  padding: 16px;
  cursor: pointer;
  color: transparent;
  background-size: 30px 30px;
  background-repeat: no-repeat;
  background-position: center 16px;
  /*background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAAAXNSR…zzpfPzEGUfP2KKB8Crnal+7uOHMgIiAE+ED8K/i1Bs/gcl54ERgoMonwAAAABJRU5ErkJggg==);*/
  /*overflow: hidden;*/
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue